import PrivateRequestBase from "./rootRequest/PrivateRequestBase";
import { PrivateRequestExcel } from "./rootRequest/PrivateRequestBase";

export function stockpileReportRequest(flightId){
  return PrivateRequestBase('get', `api/generate_stockpile_report/${flightId}`)
}

